export default "__VITE_ASSET__BlpRF4eU__"